import { Directive, Output, EventEmitter, HostListener } from '@angular/core';

@Directive({
    selector: '[scrollTracker]',
    standalone: false
})
export class ScrollTrackerDirective {
  @Output() scrollingFinished = new EventEmitter<void>();

  emitted = false;

  @HostListener("window:scroll", [])
  onScroll(): void {
    let height: number = $('medpt-body').height() != undefined ? <number>$('medpt-body').height() : 0;
    if ((window.innerHeight + window.scrollY) >= height && !this.emitted) {
      this.emitted = true;
      this.scrollingFinished.emit();
    } else if ((window.innerHeight + window.scrollY) < height) {
      this.emitted = false;
    }
  }
}
